<rdo-chart-export-buttons [config]="chartConfig"></rdo-chart-export-buttons>
<div class="active tab-pane" [rdo-highcharts]="chartConfig" [useVendorExport]="false"></div>
